import { useState } from "react";

import { trpc } from "../trpc";

export type VerifyState = "idle" | "sending" | "sent";

interface UseVerifyEmailReturn {
  state: VerifyState;
  error: string | null;
  resend: () => Promise<void>;
}

// Resends the BetterAuth verification email + tracks state. Used by
// the Account section when the signed-in user is unverified.
export function useVerifyEmail(): UseVerifyEmailReturn {
  const [state, setState] = useState<VerifyState>("idle");
  const [error, setError] = useState<string | null>(null);

  async function resend(): Promise<void> {
    setError(null);
    setState("sending");
    try {
      await trpc.user.sendVerificationEmail.mutate();
      setState("sent");
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "couldn't resend verification",
      );
      setState("idle");
    }
  }

  return { state, error, resend };
}
